import { provideAppInitializer } from '@angular/core'

import { JwtHelperService } from '@auth0/angular-jwt'

import { UserData } from '@models/oauth.models'

const storageName = 'userData'
const storaged = Boolean(localStorage.getItem(storageName))
const helper = new JwtHelperService()

export const verifyTokenFactory = provideAppInitializer(() => {
	if (!storaged) return

	const { refresh_token } = JSON.parse(localStorage.getItem(storageName)) as UserData

	if (helper.isTokenExpired(refresh_token)) {
		localStorage.clear()
	}
})
